import { PhoneCall, MessageSquareText, Waves } from "lucide-react"

// Frontend descriptors for the registry-driven providers. Mirrors
// Communications::Providers on the backend: `fields` are the non-secret config
// keys, `secrets` the write-only credentials (server returns "<key>_present").
export const PROVIDER_CATALOG = {
  exotel: {
    name: "Exotel (Calls & SMS)",
    Icon: PhoneCall,
    color: "#4F46E5",
    gradient: "from-indigo-500/10 to-indigo-600/5",
    borderHover: "hover:border-indigo-300",
    description:
      "Click-to-call with recording plus DLT-compliant transactional SMS. Calls are logged on the lead timeline with duration and recording.",
    enabledHint: "When off, outbound calls & SMS via Exotel are paused (testing still works).",
    fields: [
      { key: "account_sid", label: "Account SID", placeholder: "Your Exotel account SID" },
      { key: "subdomain", label: "API subdomain", placeholder: "api.in.exotel.com" },
      { key: "caller_id", label: "Caller ID (ExoPhone)", placeholder: "e.g. 08039510XXXX" },
      { key: "dlt_entity_id", label: "DLT entity ID", placeholder: "Registered DLT entity id" },
    ],
    secrets: [
      { key: "api_key", label: "API key" },
      { key: "api_token", label: "API token" },
    ],
    testLabel: "Send a test SMS",
  },
  msg91: {
    name: "MSG91 (SMS & WhatsApp)",
    Icon: MessageSquareText,
    color: "#DC2626",
    gradient: "from-red-500/10 to-red-600/5",
    borderHover: "hover:border-red-300",
    description:
      "Template-based DLT SMS via the Flow API and WhatsApp messaging. Delivery reports update message status automatically.",
    enabledHint: "When off, outbound SMS & WhatsApp via MSG91 are paused (testing still works).",
    // MSG91 SMS is template-driven: our rendered message text is passed as a
    // single `body` variable into this Flow template. It must therefore be a
    // DLT-approved template whose content is exactly one variable (e.g. "##body##").
    fields: [
      { key: "sender_id", label: "Sender ID (DLT header)", placeholder: "e.g. EXMPL" },
      {
        key: "default_template_id", label: "Default flow template ID",
        placeholder: "DLT Flow template id",
        hint: "Must be a single-variable passthrough template (content = one variable, e.g. ##body##). The rendered message is sent as that variable.",
      },
      { key: "integrated_number", label: "WhatsApp number", placeholder: "WhatsApp business number (optional)" },
    ],
    secrets: [{ key: "authkey", label: "Auth key" }],
    testLabel: "Send a test SMS",
  },
  springedge: {
    name: "Spring Edge (SMS)",
    Icon: Waves,
    color: "#0891B2",
    gradient: "from-cyan-500/10 to-cyan-600/5",
    borderHover: "hover:border-cyan-300",
    description:
      "Simple DLT SMS via InstantAlerts. Note: Spring Edge has no delivery-status webhook, so messages stay at “sent” once accepted.",
    enabledHint: "When off, outbound SMS via Spring Edge is paused (testing still works).",
    fields: [{ key: "sender_id", label: "Sender ID (DLT header)", placeholder: "e.g. SEDEMO" }],
    secrets: [{ key: "apikey", label: "API key" }],
    testLabel: "Send a test SMS",
  },
}
